import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/board',
      name: 'board',
      component: () => import('@/views/device/board')
    },
    {
      path: '/demo',
      name: 'main',
      component: () => import('@/views/demo/main')
    },
    {
      path: '/devices',
      name: 'devices',
      component: () => import('@/views/map/devices')
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('@/views/qqmap/search')
    },
    {
      path: '/cluster',
      name: 'cluster',
      component: () => import('@/views/qqmap/cluster'),
      props: route => ({ list: route.query.list })
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('@/views/qqmap/test')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js